(function () {
  'use strict';

  var VERSION = '3.1.0';
  var CART_ENDPOINT_PATTERN = /\/cart(\.js)?(\?|$)|\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var CART_SECTION_PATTERN = /[?&]section_id=(api-cart-items|cart-drawer)/;

  var DEBUG =
    /(?:\?|&)sib_debug=1(?:&|$)/.test(window.location.search) ||
    window.localStorage.getItem('sib_debug') === '1';

  function log() {
    if (!DEBUG) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[shipping-bar]');
    console.log.apply(console, args);
  }

  function toMoneyCents(value) {
    var amount = Number(value);
    if (isNaN(amount)) return null;
    return amount >= 100000 ? amount : amount * 100;
  }

  function parseCLPFromText(text) {
    if (!text) return null;
    if (/free|gratis/i.test(text)) return 0;

    var digits = String(text).replace(/[^\d]/g, '');
    if (!digits) return null;

    return Number(digits) * 100;
  }

  function isCartNetworkRequest(url) {
    if (!url) return false;
    return CART_ENDPOINT_PATTERN.test(String(url)) || CART_SECTION_PATTERN.test(String(url));
  }

  var ShippingBarRegistry = {
    bars: [],
    syncTimer: null,

    register: function (bar) {
      if (this.bars.indexOf(bar) === -1) {
        this.bars.push(bar);
      }
    },

    unregister: function (bar) {
      var index = this.bars.indexOf(bar);
      if (index > -1) {
        this.bars.splice(index, 1);
      }
    },

    syncAll: function (options) {
      this.bars.forEach(function (bar) {
        if (bar.root && bar.root.isConnected) {
          bar.syncFromCart(options);
        }
      });
    },

    scheduleSync: function (options, delay) {
      var self = this;
      window.clearTimeout(this.syncTimer);
      this.syncTimer = window.setTimeout(function () {
        self.syncAll(options);
      }, delay || 0);
    }
  };

  function ShippingBar(root) {
    this.root = root;
    this.thresholdDiscount = Number(root.dataset.thresholdDiscount || 0);
    this.thresholdFree = Number(root.dataset.thresholdFree || 0);
    this.messageDiscount = root.dataset.messageDiscount || 'Agrega $X más y ahorra $2.000 en tu envío';
    this.messageAlmostFree = root.dataset.messageAlmostFree || 'Te faltan $X para envío gratis';
    this.messageFree = root.dataset.messageFree || 'Tu envío es gratis';
    this.blockId = root.dataset.blockId || '';
    this.barPosition = root.dataset.barPosition || 'sticky';
    this.inDrawer = root.dataset.inDrawer === 'true';

    this.messageElement = null;
    this.contentElement = null;
    this.progressElement = null;
    this.progressFillElement = null;
    this.spacerElement = null;

    this.lastMessage = '';
    this.lastTier = '';
    this.lastSubtotal = null;
    this.fetchTimer = null;
    this.isAnimating = false;
    this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.handleAnimationEnd = this.onAnimationEnd.bind(this);
    this.handleResize = this.updateFixedSpacer.bind(this);
  }

  ShippingBar.prototype.cacheElements = function () {
    this.messageElement = this.root.querySelector('[data-shipping-message]');
    this.contentElement = this.root.querySelector('[data-shipping-content]');
    this.progressElement = this.root.querySelector('[data-progress-bar]');
    this.progressFillElement = this.root.querySelector('[data-progress-fill]');
    this.spacerElement = this.root.nextElementSibling;
  };

  ShippingBar.prototype.init = function () {
    this.cacheElements();

    if (!this.messageElement || !this.contentElement) {
      console.warn('[shipping-bar] init fallido — faltan elementos en', this.blockId || '(sin id)');
      return false;
    }

    if (this.root.dataset.sibReady === 'true') {
      return true;
    }

    this.root.dataset.sibReady = 'true';
    ShippingBarRegistry.register(this);

    if (this.messageElement.textContent) {
      this.lastMessage = this.messageElement.innerHTML;
    }

    this.messageElement.addEventListener('animationend', this.handleAnimationEnd);
    window.addEventListener('resize', this.handleResize);
    this.updateFixedSpacer();
    this.syncFromCart({ force: true, animate: false, source: 'init' });

    log('init ok', {
      blockId: this.blockId,
      thresholdDiscount: this.thresholdDiscount,
      thresholdFree: this.thresholdFree
    });

    return true;
  };

  ShippingBar.prototype.getScope = function () {
    if (this.inDrawer) {
      return document.querySelector('cart-drawer') || document;
    }
    return document;
  };

  ShippingBar.prototype.getSubtotalFromPage = function () {
    var scope = this.getScope();
    var nodes = scope.querySelectorAll('[data-cart-total], .cart__total__price--animated');

    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var attr = el.getAttribute('data-cart-total');

      if (attr !== null && attr !== '') {
        var fromAttr = toMoneyCents(attr);
        if (fromAttr !== null) {
          log('subtotal attr', fromAttr, el);
          return fromAttr;
        }
      }

      var fromText = parseCLPFromText(el.textContent);
      if (fromText !== null) {
        log('subtotal texto', fromText, el.textContent);
        return fromText;
      }
    }

    return null;
  };

  ShippingBar.prototype.syncFromCart = function (options) {
    var self = this;
    var animate = options && options.animate === true;
    var domSubtotal = this.getSubtotalFromPage();

    if (domSubtotal !== null) {
      this.renderMessage(domSubtotal, { animate: animate, force: true });
    }

    window.clearTimeout(this.fetchTimer);
    this.fetchTimer = window.setTimeout(function () {
      self.fetchAndUpdate(options);
    }, 0);
  };

  ShippingBar.prototype.fetchAndUpdate = function (options) {
    var self = this;

    fetch('/cart.js?t=' + Date.now(), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('No se pudo leer /cart.js (' + response.status + ')');
        }
        return response.json();
      })
      .then(function (cart) {
        var subtotal = toMoneyCents(
          cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price
        );

        log('subtotal /cart.js', subtotal, cart);

        if (subtotal !== null) {
          self.renderMessage(subtotal, {
            animate: options && options.animate === true,
            force: true
          });
        }
      })
      .catch(function (error) {
        console.error('[shipping-bar] Error actualizando:', error);
      });
  };

  ShippingBar.prototype.renderMessage = function (subtotal, options) {
    if (!this.messageElement) return;

    var animate = options && options.animate === true;
    var force = !options || options.force !== false;
    var normalizedSubtotal = toMoneyCents(subtotal);

    if (normalizedSubtotal === null) return;

    var message = '';
    var tier = '';

    if (normalizedSubtotal < this.thresholdDiscount) {
      message = this.replacePlaceholder(this.messageDiscount, this.thresholdDiscount - normalizedSubtotal);
      tier = 'discount';
    } else if (normalizedSubtotal < this.thresholdFree) {
      message = this.replacePlaceholder(this.messageAlmostFree, this.thresholdFree - normalizedSubtotal);
      tier = 'almost-free';
    } else {
      message = this.messageFree;
      tier = 'free';
    }

    message = this.highlightAmounts(message);

    var tierChanged = tier !== this.lastTier;
    var subtotalChanged = this.lastSubtotal !== normalizedSubtotal;
    var messageChanged = message !== this.lastMessage;

    log('render', { subtotal: normalizedSubtotal, tier: tier, message: message });

    this.updateProgressBar(normalizedSubtotal, tier);
    this.lastSubtotal = normalizedSubtotal;

    if (!force && !tierChanged && !subtotalChanged && !messageChanged) {
      return;
    }

    if (!animate || this.prefersReducedMotion || !messageChanged) {
      this.setMessage(message, tier, tier === 'free' && tierChanged);
      return;
    }

    this.animateMessageChange(message, tier);
  };

  ShippingBar.prototype.getProgressPercent = function (subtotal, tier) {
    var total = Number(subtotal) || 0;

    if (tier === 'free') return 100;

    if (tier === 'almost-free') {
      var range = this.thresholdFree - this.thresholdDiscount;
      if (range <= 0) return 100;
      var current = total - this.thresholdDiscount;
      return Math.min(100, Math.max(0, (current / range) * 100));
    }

    if (this.thresholdDiscount <= 0) return 0;
    return Math.min(100, Math.max(0, (total / this.thresholdDiscount) * 100));
  };

  ShippingBar.prototype.updateProgressBar = function (subtotal, tier) {
    if (!this.progressFillElement) return;

    var percent = Math.round(this.getProgressPercent(subtotal, tier));
    this.progressFillElement.style.width = percent + '%';

    if (this.progressElement) {
      this.progressElement.setAttribute('aria-valuenow', String(percent));
      this.progressElement.classList.toggle('has-progress', percent > 0);
    }

    if (this.contentElement) {
      this.contentElement.classList.toggle('is-complete', tier === 'free');
    }
  };

  ShippingBar.prototype.replacePlaceholder = function (template, remainingCents) {
    var formatted = this.formatCurrency(remainingCents);
    return template.replace(/\$X/g, formatted).replace(/\|\|amount\|\|/g, formatted);
  };

  ShippingBar.prototype.animateMessageChange = function (message, tier) {
    if (!this.messageElement) return;

    if (this.isAnimating) {
      this.setMessage(message, tier, tier === 'free' && this.lastTier !== 'free');
      return;
    }

    var self = this;
    this.isAnimating = true;
    this.messageElement.classList.add('is-changing');

    window.setTimeout(function () {
      self.setMessage(message, tier, tier === 'free' && self.lastTier !== 'free');
      self.messageElement.classList.remove('is-changing');

      if (!self.prefersReducedMotion) {
        self.messageElement.classList.remove('is-entering');
        void self.messageElement.offsetWidth;
        self.messageElement.classList.add('is-entering');
      } else {
        self.isAnimating = false;
      }
    }, 220);
  };

  ShippingBar.prototype.setMessage = function (message, tier, pulse) {
    if (!this.messageElement) return;

    this.messageElement.innerHTML = message;
    this.lastMessage = message;
    this.lastTier = tier;

    if (this.lastSubtotal !== null) {
      this.updateProgressBar(this.lastSubtotal, tier);
    }

    if (pulse && this.contentElement && !this.prefersReducedMotion) {
      this.contentElement.classList.remove('is-complete');
      void this.contentElement.offsetWidth;
      this.contentElement.classList.add('is-complete');
    }
  };

  ShippingBar.prototype.onAnimationEnd = function (event) {
    if (!event || !event.target) return;

    if (event.target.classList.contains('is-entering')) {
      event.target.classList.remove('is-entering');
      this.isAnimating = false;
    }

    if (event.target.classList.contains('is-complete')) {
      event.target.classList.remove('is-complete');
    }
  };

  ShippingBar.prototype.formatCurrency = function (amountInCents) {
    var amount = Math.max(0, Math.round(amountInCents / 100));
    return '$' + amount.toLocaleString('es-CL');
  };

  ShippingBar.prototype.highlightAmounts = function (message) {
    var self = this;
    return message.replace(/(\$\d{1,3}(?:\.\d{3})*)/g, function (match) {
      return '<span class="shipping-bar__amount-' + self.blockId + '">' + match + '</span>';
    });
  };

  ShippingBar.prototype.updateFixedSpacer = function () {
    if (this.barPosition !== 'fixed' || !this.spacerElement) return;

    var height = this.root.offsetHeight || this.root.getBoundingClientRect().height;
    if (height > 0) {
      this.spacerElement.style.height = height + 'px';
    }
  };

  function initAllBars() {
    var nodes = document.querySelectorAll('[data-shipping-incentive-bar]');
    var initialized = 0;

    nodes.forEach(function (root) {
      if (!root.shippingBarController) {
        root.shippingBarController = new ShippingBar(root);
      }

      if (root.shippingBarController.init()) {
        initialized += 1;
      }
    });

    console.log('[shipping-bar] v' + VERSION + ' — barras:', initialized + '/' + nodes.length);
    return initialized;
  }

  function installBridge() {
    if (window.__shippingIncentiveBarBridgeInstalled) return;
    window.__shippingIncentiveBarBridgeInstalled = true;

    function onCartActivity(source, delay) {
      ShippingBarRegistry.scheduleSync({ force: true, animate: true, source: source }, delay || 0);
    }

    var originalFetch = window.fetch;
    if (typeof originalFetch === 'function') {
      window.fetch = function () {
        var request = arguments[0];
        var url = typeof request === 'string' ? request : request && request.url;
        var isCartRequest = isCartNetworkRequest(url);

        return originalFetch.apply(this, arguments).then(function (response) {
          if (isCartRequest && response && response.ok) {
            onCartActivity('fetch:' + url, /\/cart\/(change|add|update|clear)/.test(String(url)) ? 600 : 150);
          }
          return response;
        });
      };
    }

    var originalOpen = XMLHttpRequest.prototype.open;
    var originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__sibCartUrl = url;
      return originalOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
      var xhr = this;
      var url = xhr.__sibCartUrl;

      if (isCartNetworkRequest(url)) {
        xhr.addEventListener('loadend', function () {
          if (xhr.status >= 200 && xhr.status < 300) {
            onCartActivity('xhr:' + url, 600);
          }
        });
      }

      return originalSend.apply(this, arguments);
    };

    [
      'theme:cart:change',
      'theme:cart:update',
      'theme:product:add',
      'theme:product:added',
      'theme:cart-drawer:open'
    ].forEach(function (eventName) {
      document.addEventListener(eventName, function () {
        initAllBars();
        onCartActivity(eventName, eventName === 'theme:cart:change' ? 50 : 300);
      });
    });

    document.addEventListener('shopify:section:load', function () {
      initAllBars();
      onCartActivity('shopify:section:load', 100);
    });

    document.addEventListener('change', function (event) {
      var target = event.target;
      if (!target || !target.closest('cart-drawer, [data-section-type="cart"], cart-items')) return;
      if (target.matches('input[name="updates[]"], [name="quantity"]')) {
        onCartActivity('qty-change', 700);
      }
    });

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest('cart-drawer, [data-section-type="cart"], cart-items')) return;
      if (target.closest('[data-quantity-button], [data-increase-qty], [data-decrease-qty], .quantity__button, [data-cart-remove]')) {
        onCartActivity('qty-click', 700);
      }
    });

    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof MutationObserver !== 'undefined') {
      var observer = new MutationObserver(function () {
        onCartActivity('drawer-mutation', 80);
      });

      observer.observe(cartDrawer, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['data-cart-total']
      });
    }
  }

  function boot() {
    installBridge();
    initAllBars();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.ShippingIncentiveBar = {
    version: VERSION,
    init: initAllBars,
    sync: function () {
      ShippingBarRegistry.syncAll({ force: true, animate: false, source: 'manual' });
    },
    debug: function (enabled) {
      if (enabled === false) {
        window.localStorage.removeItem('sib_debug');
      } else {
        window.localStorage.setItem('sib_debug', '1');
      }
      console.log('[shipping-bar] Debug', enabled === false ? 'off' : 'on', '— recarga la página');
    }
  };
})();
